export enum ResponseType {
  ARRAYBUFFER = <any>'arraybuffer',
  BLOB = <any>'blob',
  JSON = <any>'json',
  TEXT = <any>'text'
}
